import { createMutation } from '@hum/api/src/utils/createMutation';
import { FinancialDocumentsTaskParams } from '@hum/types';
import { FinancialDocumentsTask } from '@hum/types';

export const createFinancialDocumentDownloadTask = createMutation<
  FinancialDocumentsTask,
  FinancialDocumentsTaskParams
>(
  ({ api, payload }) => {
    if (!payload.connectorType || !payload.connectorSource) {
      return api.post(
        `/v3/companies/${payload.companyId}/analytics_download_tasks`,
        {
          doc_type: payload.docType,
        }
      );
    }
    return api.post(
      `/v3/companies/${payload.companyId}/analytics_download_tasks`,
      {
        doc_type: payload.docType,
        connector_type: payload.connectorType,
        connector_source: payload.connectorSource,
      }
    );
  },
  {
    errorToast: { message: 'Failed to download' },
  }
);
